import { ResourceAction, ResourceScope } from '@app/types/blackroom-app';

export function getResourceActionsFromScope(
  scope: ResourceScope,
): ResourceAction[] {
  switch (scope) {
    case 'archived':
      return ['restore', 'delete'];

    case 'favorites':
      return ['download', 'unfavorite'];

    case 'my':
    case 'recent':
    case 'redacted':
    case 'search':
    default:
      return [
        'download',
        'rename',
        'redact',
        'move',
        'reprocess',
        'share',
        'favorite',
        'unfavorite',
        'archive',
        'copy',
        'cut',
      ];
  }
}
